<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div
    v-if="results && results.length > 0"
    class="nopads"
  >
    <div class="row col-12">
      <div class="col nopads report-header">
        <div class="row nopads">
          <div class="col nopads">
            <span
              class="section-title"
              style="display: block"
            >{{ $t('material_reports.title') }}</span>
            <div>{{ results ? results.length : 0 }} {{ $t('danger_report.reports') }}</div>
          </div>
          <div class="col">
            <div class="button-container">
            <div
                class="dropdown"
            >
                <button
                    class="btn btn-sm btn-outline-success dropdown-toggle form-button dont-print"
                    type="button"
                    data-bs-toggle="dropdown"
                >
                    {{ $t('trip.download_excel') }}
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                        <button
                            class="dropdown-item"
                            type="button"
                            @click="exportExcel(false)"
                        >
                            {{ $t('trip.download_material_report_full') }}
                        </button>
                    </li>
                    <li>
                        <button
                            class="dropdown-item"
                            type="button"
                            @click="exportExcel(true)"
                        >
                            {{ $t('trip.download_material_report_hourly') }}
                        </button>
                    </li>
                </ul>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="list-content result-table">
          <vue3-datatable
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="60vh"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
          >
              <template #reporting_date="data">
                  {{ data.value.reporting_date ? getShortDateString(data.value.reporting_date) : '' }}
              </template>
          </vue3-datatable>
      </div>
    </div>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {downloadHelper} from '../mixins/DownloadMixin'
import Vue3Datatable from '@bhplugin/vue3-datatable'
import {inject} from "vue";

export default {
    name: 'MaterialReport',
    mixins: [restApi, timeUtils, downloadHelper],
    components: {Vue3Datatable},
    props: {
        user: {
            type: Object,
            default: null
        },
        params: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            results: [],
            materialData: [],
            labels: [],
            materialTitle: this.$t('material_report.chart_title')
        }
    },
    computed: {
        fields() {
            return [
                { field: 'reporting_date', title: this.$t('daily_summary.date'), sort: true, headerClass: 'routa-table-header' },
                { field: 'reporter_name', title: this.$t('material_reports.reporter'), sort: true, headerClass: 'routa-table-header' },
                { field: 'customer_name', title: this.$t('contracts.customer'), sort: true, headerClass: 'routa-table-header' },
                { field: 'contract_name', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header' },
                { field: 'order_name', title: this.$t('orders.order'), sort: true, headerClass: 'routa-table-header' },
                { field: 'material', title: this.$t('material_reports.material'), sort: true, headerClass: 'routa-table-header' },
                { field: 'amount', title: this.$t('material_reports.amount'), sort: true, headerClass: 'routa-table-header' },
                { field: 'unit', title: this.$t('material_reports.unit'), sort: true, headerClass: 'routa-table-header' },
                { field: 'info', title: this.$t('material_reports.info'), sort: true, headerClass: 'routa-table-header' }
            ]
        }
    },
    watch: {
        params: function () {
            this.fetchReports()
        }
    },
    mounted: function () {
        this.fetchReports()
    },
    methods: {
        fetchReports: function () {
            this.results = []
            if (this.params) {
                this.loading = true
                this.restFetchParams(this.materialReportUrl, this.params, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response && response.data) {
                this.results = response.data
            }
            this.loading = false
        },
        exportExcel: function (trimmed) {
            this.loading = true

            let materialReportParams = Object.assign({}, this.params, {trim: trimmed ? 1 : 0 })

            this.restGetDownloadFile(this.materialReportExcelUrl, this.getCommonReportParams(materialReportParams), this.fileDownloadSuccess, this.fileDownloadFail)
        },
        fileDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('material_reports.file_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
    }
}
</script>
